<template>
  <div>
    <small style="float:right">{{ "created_at" in data ? elapsedTime(data.created_at) : "" }}</small>
    <div class="text-center" v-if="'image_url' in data">
      <img :src="data.image_url" style="width: 100%" v-if="data.image_url" />
    </div>
    <div class="text-lg font-bold mb-3">
      {{ "title" in data ? data.title : "" }}
    </div>
    <div>{{ "body" in data ? data.body : "" }}</div>
  </div>
</template>

<script>
import Global from "@/helper/global";

export default {
  name: "notification-details",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    elapsedTime(startTime) {
      return Global.elapsedTime(startTime);
    },
  },
};
</script>
